import BaseApiService from "./BaseApiService";

class UnauthenticatedService extends BaseApiService {}

export default new UnauthenticatedService();
